module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAtCAYAAADhoUi4AAAAp0lEQVRoge3aUQqAIBBFUY12pPtfgXuqr0ACLdTBp9zzG4SPcSbQfAjhcmU+pVR5rOdYarU/nPIrfIkxVp9TIRHFvm8K9FX2x4yBwpbLVMd9x3u7bFchAqljKIxgOfZnflhNpiQ9pI5A6gikjkDqCKSOQOoIpI5A6gikjkOSgUxOV6nQCJa3EgwFdfRQZtodUE1TIOV/F1a9NC7uDnpotq/tvleFnHM3nnwVOV9EZFkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right1.png
// module id = MYH1
// module chunks = 1